export const coordinates = ({longitude,latitude}) => [longitude,latitude];
export const X = ([x,]) => x;
export const Y = ([,y]) => y;